<p-tabs scrollable value="0" class="eventDash" (onChange)="onTabChange($event)">
  <p-tablist>
    <p-tab value="0">Event Count</p-tab>
    <p-tab value="1">Events POE Documents</p-tab>
    <p-tab value="2">All Events</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (isEventCountSelected) {
        <app-events-count></app-events-count>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-events-poe-documents></app-events-poe-documents>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-all-events></app-all-events>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
